<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <!-- 基本信息 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            @getMemberFn="resetMemberFn"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :activityId="79"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="活动设置"></jd-title>
          <div class="mt20">
            <el-form-item label="盖楼口令设置：">
              <el-radio-group
                v-model="ruleDTO.codeSettingType"
                :disabled="activityData.isStart"
                @change="changeActivityType"
              >
                <el-radio :label="0"
                  >不关联任务，自行在其他途径透出口令</el-radio
                >
                <el-radio :label="1">关联任务</el-radio>
              </el-radio-group>
              <div class="mt16">
                <singleTaskComponent
                  v-if="ruleDTO.codeSettingType == 1"
                  :taskList.sync="taskDataList"
                  :copySteList.sync="taskLevelList"
                  :activityStartTime="ruleForm.startTime"
                  :mainText="mainText"
                  :extraText="extraText"
                  :taskOrders.sync="taskOrderList"
                  :activityData="activityData"
                />
                <div v-else>
                  <jd-button
                    type="blue"
                    @click="addCode"
                    :disabled="codeList.length >= 20"
                    >新增口令（{{ codeList.length }}/20）</jd-button
                  >
                  <span class="extra-text ml8"
                    >每条口令每位用户仅可使用一次</span
                  >
                  <div class="code-box">
                    <div
                      class="code-item"
                      v-for="(item, index) in codeList"
                      :key="item.id"
                    >
                      <el-input
                        class="w400"
                        show-word-limit
                        maxlength="20"
                        v-model="item.code"
                        placeholder="请输入"
                        @blur="checkCode(item)"
                      />
                      <jd-button
                        type="blueText"
                        class="ml12"
                        @click="removeCode(index)"
                        >删除</jd-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="盖楼限制：" required>
              <div>
                <span class="mr8">每人每天最多盖楼次数</span>
                <el-input
                  class="w125"
                  @input="
                    ruleDTO.oneDayMaxBuildFloorNumber = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999
                    )
                  "
                  v-model="ruleDTO.oneDayMaxBuildFloorNumber"
                  placeholder="请输入"
                />
                <span class="ml8">次</span>
              </div>
              <div class="mt12">
                <span class="mr8">每人连续盖楼最多</span>
                <el-input
                  class="w125"
                  @input="
                    ruleDTO.maxContinuousBuildFloorNumber = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999
                    )
                  "
                  v-model="ruleDTO.maxContinuousBuildFloorNumber"
                  placeholder="请输入"
                />
                <span class="ml8">次</span>
              </div>
              <div class="mt12">
                <span class="mr8">活动期间每人累计最多盖楼次数</span>
                <el-input
                  class="w125"
                  @input="
                    ruleDTO.totalMaxBuildFloorNumber = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999
                    )
                  "
                  v-model="ruleDTO.totalMaxBuildFloorNumber"
                  placeholder="请输入"
                />
                <span class="ml8">次</span>
              </div>
            </el-form-item>
          </div>
          <!-- 奖品设置 -->
          <jd-title label="奖品设置"></jd-title>
          <div>
            <el-form-item label="奖品设置：">
              <div class="mb10">
                同一用户最多仅可中奖 1
                次，命中任意奖品后，后续楼层不再触发中奖资格；同一楼层触发多个奖项时，仅发放顺位在前的奖品，不叠加领奖；
              </div>
              <newPrizeTable
                :prizeList.sync="prizeSetting"
                :isDisabled="activityData.isStart"
                :tableInfo="tableInfo"
                :valueRow="valueRow"
                :isShowUpLoadBtn="true"
                :actType="39"
                :isShowMoveBtn="isShowMoveBtn"
                :actEndTime="ruleForm.endTime"
              >
                <template #dailyLimitName="{ scopeRow }">
                  <dailyLimitConfig
                    :row="scopeRow"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
                <!-- 作用域插槽实现额外字段的输入 -->
                <template #winConditionName="{ scopeRow, scopeIndex }">
                  <jd-button
                    v-if="
                      !scopeRow.buildFloorWinConditionDTO
                        .specifiedWinFloorList &&
                      !scopeRow.buildFloorWinConditionDTO.multipleFloorNumber &&
                      !scopeRow.buildFloorWinConditionDTO.winFloorRangeStart &&
                      !scopeRow.buildFloorWinConditionDTO.winFloorRangeEnd &&
                      !scopeRow.buildFloorWinConditionDTO.winFloorTailNumber
                    "
                    type="blueText"
                    @click="setWinCondition(scopeRow, scopeIndex)"
                    >楼层设置</jd-button
                  >
                  <div class="condition-box" v-else>
                    <span
                      v-if="
                        scopeRow.buildFloorWinConditionDTO.winType == 0 &&
                        scopeRow.buildFloorWinConditionDTO.specifiedWinFloorList
                      "
                    >
                      指定{{
                        scopeRow.buildFloorWinConditionDTO
                          .specifiedWinFloorList
                      }}楼层中奖
                    </span>
                    <span
                      v-else-if="
                        scopeRow.buildFloorWinConditionDTO.winType == 1 &&
                        scopeRow.buildFloorWinConditionDTO
                          .multipleFloorNumber &&
                        scopeRow.buildFloorWinConditionDTO.winFloorRangeStart &&
                        scopeRow.buildFloorWinConditionDTO.winFloorRangeEnd
                      "
                    >
                      中奖楼层为{{
                        scopeRow.buildFloorWinConditionDTO.multipleFloorNumber
                      }}的倍数，中奖范围{{
                        scopeRow.buildFloorWinConditionDTO.winFloorRangeStart
                      }}-{{
                        scopeRow.buildFloorWinConditionDTO.winFloorRangeEnd
                      }}
                    </span>
                    <span
                      v-else-if="
                        scopeRow.buildFloorWinConditionDTO.winType == 2 &&
                        scopeRow.buildFloorWinConditionDTO.winFloorTailNumber >=
                          0 &&
                        scopeRow.buildFloorWinConditionDTO.winFloorRangeStart &&
                        scopeRow.buildFloorWinConditionDTO.winFloorRangeEnd
                      "
                    >
                      中奖楼层尾号为{{
                        scopeRow.buildFloorWinConditionDTO.winFloorTailNumber
                      }}，中奖范围{{
                        scopeRow.buildFloorWinConditionDTO.winFloorRangeStart
                      }}-{{
                        scopeRow.buildFloorWinConditionDTO.winFloorRangeEnd
                      }}
                    </span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/message_otification/edit.png"
                      alt=""
                      class="edit-icon"
                      v-if="!activityData.isStart"
                      @click="setWinCondition(scopeRow, scopeIndex)"
                    />
                  </div>
                </template>
              </newPrizeTable>
              <jd-button
                class="mt16"
                type="blue"
                :disabled="activityData.isStart || prizeSetting.length >= 5"
                @click="addPrizeSetting"
                >+增加奖品（{{ prizeSetting.length }}/5）</jd-button
              >
            </el-form-item>
          </div>
          <div class="mt20"></div>
          <!-- 活动页设置 -->
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            :templateId="templateId"
            :isShowDesignNumber="false"
            previewKey="url"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="1740"
            :isCustomPreview="true"
            :downloadTemplateUrl="templateUrl"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/building-etiquette-design.png"
            themeTitle="主题"
            :defaultRgb="currrentRgb"
            v-model="customerPaperwork"
            @selectTemplate="selectTemplate"
          >
            <template #customPreview>
              <buildingCourtesyDialog
                :ruleForm="ruleForm"
                :ruleDTO="ruleDTO"
                :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :productList="prizeSetting"
              />
            </template>
            <template #otherSet>
              <!-- 自定义活动页设置 -->
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <el-form-item label="背景图：" label-width="70px">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 1)"
                        :on-success="(res) => handleUploadUI(res, 1)"
                      >
                        <div class="bg-wrap" v-if="customerPaperwork.url2">
                          <img
                            :src="customerPaperwork.url2"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.url2 = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：560*94px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="颜色：" label-width="70px">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.btnColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.btnColor = currrentRgb2"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="奖品剩余库存：" label-width="155px">
                <el-radio-group v-model="customerPaperwork.showStock">
                  <el-radio :label="false">不显示</el-radio>
                  <el-radio :label="true"
                    >显示（C端活动页奖品显示剩余库存）</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="中奖信息是否公布：" label-width="155px">
                <el-radio-group v-model="customerPaperwork.showWinnerInfo">
                  <el-radio :label="false">不公布</el-radio>
                  <el-radio :label="true"
                    >公布（C端活动页展示中奖信息）</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </template>
          </activityPageSettings>
          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
            :activityData="activityData"
            :valueRow="valueRow"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 设置中奖条件 -->
    <jd-dialog
      title="设置中奖条件"
      :visible.sync="isShowWinCondition"
      width="700px"
      @confirm="getWinCondition"
      @close="handleCloseWinCondition"
    >
      <div>
        <el-form
          :model="winConditionForm"
          ref="winConditionFormRef"
          :rules="conditionRule"
          label-width="auto"
        >
          <el-form-item label="中奖类型:" prop="winType" required>
            <el-radio-group
              v-model="winConditionForm.winType"
              @change="changeWinType"
            >
              <el-radio :label="0">指定中奖楼层</el-radio>
              <el-radio :label="1">整数倍数</el-radio>
              <el-radio :label="2">楼层尾号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="指定中奖楼层:"
            v-if="winConditionForm.winType == 0"
            prop="specifiedWinFloorList"
          >
            <div class="flex-c">
              <el-input
                type="textarea"
                class="w400"
                v-model="winConditionForm.specifiedWinFloorList"
                placeholder="请输入"
                show-word-limit
                :maxlength="500"
                :autosize="{ minRows: 4, maxRows: 6 }"
                @input="
                  winConditionForm.specifiedWinFloorList =
                    handleInputSpecifiedWinFloor($event)
                "
              ></el-input>
              <span>请输入楼层号，以英文逗号（,）分隔，最多500个字符</span>
            </div>
          </el-form-item>
          <el-form-item
            label="中奖楼层号为:"
            v-if="winConditionForm.winType == 1"
            prop="multipleFloorNumber"
          >
            <el-input
              class="w125"
              v-model="winConditionForm.multipleFloorNumber"
              placeholder="请输入"
              @input="
                winConditionForm.multipleFloorNumber = handleInput($event)
              "
            ></el-input>
            <span class="ml8">的整数倍</span>
          </el-form-item>
          <el-form-item
            label="中奖楼层尾号:"
            v-if="winConditionForm.winType == 2"
            prop="winFloorTailNumber"
          >
            <el-input
              class="w125"
              v-model="winConditionForm.winFloorTailNumber"
              placeholder="请输入"
              @input="
                winConditionForm.winFloorTailNumber =
                  handleInputWinFloorTailNumber($event)
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            label="中奖楼层范围:"
            v-if="
              winConditionForm.winType == 1 || winConditionForm.winType == 2
            "
          >
            <div class="flex-c">
              <div class="flexc">
                <el-form-item prop="winFloorRangeStart">
                  <el-input
                    class="w125"
                    v-model="winConditionForm.winFloorRangeStart"
                    placeholder="请输入"
                    @input="
                      winConditionForm.winFloorRangeStart = handleInput($event)
                    "
                    @blur="handleBlurWinFloorRangeStart($event)"
                  ></el-input>
                </el-form-item>
                <span class="mlr8">~</span>
                <el-form-item prop="winFloorRangeEnd">
                  <el-input
                    class="w125"
                    v-model="winConditionForm.winFloorRangeEnd"
                    placeholder="请输入"
                    @input="
                      winConditionForm.winFloorRangeEnd = handleInput($event)
                    "
                    @blur="handleBlurWinFloorRangeEnd($event)"
                  ></el-input>
                </el-form-item>
              </div>
              <span v-if="winConditionForm.winType == 1">
                例如5的倍数，100-200层，则中奖楼层为5，10，15，20，25，30，.......
              </span>
              <span v-else>
                例如尾号8，100-200层，则中奖楼层为108，118，128，138，......
              </span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </jd-dialog>
  </div>
</template>

<script>
import {
  saveOrUpdateBuildingGift,
  getBuildingGiftDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import {
  conditionValue,
  getTaskTypeOptions,
} from "./components/singleTaskComponent/data.js";
import buildingCourtesyDialog from "./components/newActPreviews/building-courtesy-dialog.vue";
import singleTaskComponent from "./components/singleTaskComponent";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import {useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    buildingCourtesyDialog,
    singleTaskComponent,
    newPrizeTable,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentIndex: 0,
      taskLevelList: [],
      isShowMoveBtn: true,
      conditionRule: {
        specifiedWinFloorList: [
          { required: true, message: "请输入指定中奖楼层", trigger: "blur" },
        ],
        multipleFloorNumber: [
          {
            required: true,
            message: "请输入中奖楼层号的整数倍",
            trigger: "blur",
          },
        ],
        winFloorTailNumber: [
          { required: true, message: "请输入中奖楼层尾号", trigger: "blur" },
        ],
        winFloorRangeStart: [
          {
            required: true,
            message: "请输入中奖开始楼层",
            trigger: "blur",
          },
        ],
        winFloorRangeEnd: [
          {
            required: true,
            message: "请输入中奖结束楼层",
            trigger: "blur",
          },
        ],
      },
      winConditionForm: {
        winType: 0, //中奖类型
        specifiedWinFloorList: "", //指定中奖楼层
        multipleFloorNumber: "", //整数倍数基数
        winFloorTailNumber: "", //中奖楼层尾号
        winFloorRangeStart: "", //中奖楼层范围-开始楼层
        winFloorRangeEnd: "", //中奖楼层范围-结束楼层
      },
      isShowWinCondition: false,
      prizeSetting: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          buildFloorWinConditionDTO: {
            winType: 0, //中奖类型
            specifiedWinFloorList: "", //指定中奖楼层
            multipleFloorNumber: "", //整数倍数基数
            winFloorTailNumber: "", //中奖楼层尾号
            winFloorRangeStart: "", //中奖楼层范围-开始楼层
            winFloorRangeEnd: "", //中奖楼层范围-结束楼层
          },
        },
      ], //奖品设置
      codeList: [], //口令名称列表
      taskDataList: [], //任务列表
      taskOrderList: [],
      mainText: "盖楼口令",
      extraText: "每条口令每位用户仅可使用一次",
      itemArr: [],
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      echoDate: {},
      couponList: [],
      isLimit: true,
      isShowGoods: false,
      tableInfo: [
        {
          label: "中奖条件",
          prop: "buildFloorWinConditionDTO",
          slot: "winConditionSlot",
          slotName: "winConditionName",
          width: 250,
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          width: 160,
        },
        {
          label: "值",
          prop: "price",
          width: 130,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          width: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slotHead: "totalAmountHeader",
          slot: "totalAmountSlot",
          width: 180,
        },
        {
          label: "每日发放限额",
          slotName: "dailyLimitName",
          slot: "dailyLimit",
          width: 120,
        },
        {
          label: "图片",
          prop: "logo",
          slot: "logoSlot",
          width: 120,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 300,
        },
      ],
      windowSkuList: [],
      isShowToken: false,
      isShowExclusivePrice: false,
      exclusivePriceList: [],
      isKeyActivity: 0,
      placementPosition: [],
      isForceRemind: 0,
      templateUrl:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/%E7%9B%96%E6%A5%BC%E6%9C%89%E7%A4%BC.psd",
      conditionValue: conditionValue,
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      customerPaperwork: {
        title: "参与盖楼赢好礼",
        desc: "数量有限，先到先得",
        titleColor: "#ffffff",
        url2: "", //按钮背景图
        btnColor: "", //按钮文案颜色
        showStock: true, //是否显示奖品剩余库存
        showWinnerInfo: true, //是否公布中奖信息
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
      },
      sharePic:
        "https://cdn-image.yucrm.cn/hd/images/building-etiquette-share.png",
      ruleDTO: {
        codeSettingType: 1,
        oneDayMaxBuildFloorNumber: "", //每人每天最多盖楼次数
        maxContinuousBuildFloorNumber: "", //每人连续盖楼最多次数
        totalMaxBuildFloorNumber: "", //活动期间每人累计最多盖楼次数
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic:
          "https://cdn-image.yucrm.cn/hd/images/building-etiquette-share.png",
        openCardStartTime: "",
        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
      },
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      pickerOption: {
        disabledDate: (time) => {
          //  在活动开始-结束时间范围内
          return (
            time.getTime() < new Date(this.activityStartTime).getTime() ||
            time.getTime() >
              new Date(this.activityEndTime).getTime() - 24 * 60 * 60 * 1000
          );
        },
      },
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    taskTypeOptions() {
      return getTaskTypeOptions("盖楼口令", "个");
    },
    backgroundImage() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    }
  },
  watch: {},
  created() {
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.buriedPoint(1, "盖楼有礼", "互动管理", "互动活动");
  },

  methods: {
    resetMemberFn(val) {
      this.peopleSelected = [];
      this.ruleForm.partner = ["-1"];
      this.ruleForm.firstOpenCardTimeType = 0;
      this.ruleForm.openCardBeforeDay = "";
      this.ruleForm.orderCompleteLimitCount = "";
      this.ruleForm.orderCompleteMaxCount = "";
      this.ruleForm.orderCompleteLimitPayment = "";
      this.ruleForm.orderCompleteMaxPayment = "";
      this.ruleForm.lastOrderCompleteTimeType = 0;
      this.ruleForm.lastOrderCompleteStartDay = "";
      this.ruleForm.lastOrderCompleteEndDay = "";
      this.ruleForm.lastOrderCompleteStartTime = "";
      this.ruleForm.lastOrderCompleteEndTime = "";
      this.ruleDTO.plusObject = 0;
    },
    getValue(val) {
      // 如果val是字段串类型，则转为数组，如果是数组，则转为字符串
      if (typeof val === "string") {
        return val ? val.split(",") : [];
      } else if (Array.isArray(val)) {
        return val.length > 0 ? val.join(",") : [];
      }
      return val;
    },
    // 增加奖品设置
    addPrizeSetting() {
      if (this.prizeSetting.length >= 5) {
        return this.$message.warning("最多只能添加5个奖品");
      }
      this.prizeSetting.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
        buildFloorWinConditionDTO: {
          winType: 0, //中奖类型
          specifiedWinFloorList: "", //指定中奖楼层
          multipleFloorNumber: "", //整数倍数基数
          winFloorTailNumber: "", //中奖楼层尾号
          winFloorRangeStart: "", //中奖楼层范围-开始楼层
          winFloorRangeEnd: "", //中奖楼层范围-结束楼层
        },
      });
    },
    handleInputWinFloorTailNumber(val) {
      // 仅支持输入0~10之间的单个整数，不包含10（即只能输入0-9）
      let inputVal = val;
      // 移除非数字字符
      inputVal = inputVal.replace(/[^0-9]/g, "");
      // 只保留第一个字符（确保是单个整数）
      if (inputVal.length > 1) {
        inputVal = inputVal.slice(0, 1);
      }
      // 验证范围：只能输入0-9（不包含10）
      const num = parseInt(inputVal);
      if (isNaN(num) || num >= 10) {
        inputVal = "";
      }
      return inputVal;
    },
    handleInputSpecifiedWinFloor(val) {
      // 只能输入大于0的数字且数字后面必须以英文逗号（,）分割,且不能连续输入逗号，楼层不能重复
      let inputVal = val;
      // 移除非数字和非逗号的字符
      inputVal = inputVal.replace(/[^0-9,]/g, "");
      // 移除连续的逗号（将多个连续逗号替换为单个逗号）
      inputVal = inputVal.replace(/,+/g, ",");
      // 如果以逗号开头，移除开头的逗号
      if (inputVal.startsWith(",")) {
        inputVal = inputVal.slice(1);
      }
      // 处理以0开头的数字（去掉前导0，但保留用户正在输入的状态）
      // 保留空字符串以支持用户正在输入逗号的情况
      inputVal = inputVal
        .split(",")
        .map((floor) => {
          if (floor === "") return ""; // 保留空字符串（用户正在输入逗号）
          // 去掉前导0，如果结果为空则返回空（如单独输入"0"时）
          floor = floor.replace(/^0+(?=[1-9])/, "");
          return floor === "0" ? "" : floor; // 单独的0无效，返回空
        })
        .join(",");
      // 更新表单值
      return inputVal;
    },
    changeWinType() {
      this.winConditionForm.specifiedWinFloorList = "";
      this.winConditionForm.multipleFloorNumber = "";
      this.winConditionForm.winFloorTailNumber = "";
      this.winConditionForm.winFloorRangeStart = "";
      this.winConditionForm.winFloorRangeEnd = "";
      this.$refs.winConditionFormRef.clearValidate();
    },
    handleCloseWinCondition(val) {
      this.isShowWinCondition = false;
      this.winConditionForm.winType = 0;
      this.$refs.winConditionFormRef.clearValidate();
    },
    // 限制中奖楼层开始输入不能大于结束输入
    handleBlurWinFloorRangeStart(val) {
      // 中奖楼层号必须在中奖楼层范围内
      const newVal = val.target.value;
      if (
        this.winConditionForm.winFloorRangeEnd &&
        +newVal >= +this.winConditionForm.winFloorRangeEnd
      ) {
        this.$message.error("起始楼层不可大于等于结束楼层，请调整范围~");
        this.winConditionForm.winFloorRangeStart = "";
      }
      // 中奖楼层号必须在中奖楼层范围内
      // if (this.winConditionForm.multipleFloorNumber&&(+newVal < +this.winConditionForm.multipleFloorNumber)) {
      //   this.$message.warning("中奖楼层开始不能小于中奖楼层号");
      //   this.winConditionForm.winFloorRangeStart = "";
      // }
    },
    // 限制中奖楼层结束输入不能小于开始输入
    handleBlurWinFloorRangeEnd(val) {
      const newVal = val.target.value;
      if (
        this.winConditionForm.winFloorRangeStart &&
        +newVal <= +this.winConditionForm.winFloorRangeStart
      ) {
        this.$message.error("起始楼层不可大于等于结束楼层，请调整范围~");
        this.winConditionForm.winFloorRangeEnd = "";
      }
      // 中奖楼层号必须在中奖楼层范围内
      // if (
      //   this.winConditionForm.multipleFloorNumber &&
      //   +newVal < +this.winConditionForm.multipleFloorNumber
      // ) {
      //   this.$message.warning("中奖楼层结束不能小于中奖楼层号");
      //   this.winConditionForm.winFloorRangeEnd = "";
      // }
    },
    setWinCondition(row, index) {
      this.winConditionForm = { ...row.buildFloorWinConditionDTO };
      this.currentIndex = index;
      this.isShowWinCondition = true;
    },
    getWinCondition() {
      this.$refs.winConditionFormRef.validate((valid) => {
        if (valid) {
          if (this.winConditionForm.winType == 0) {
            // 将重复的楼层号合并
            const nums = [
              ...new Set(
                this.winConditionForm.specifiedWinFloorList.split(",")
              ),
            ];
            this.winConditionForm.specifiedWinFloorList = nums.join(",");
          } else if (this.winConditionForm.winType == 1) {
            // 输入的中奖楼层号，必须能在起始楼层～结束楼层区间内产生至少 1 个有效中奖楼层
            const multiple = parseInt(
              this.winConditionForm.multipleFloorNumber
            );
            const start = parseInt(this.winConditionForm.winFloorRangeStart);
            const end = parseInt(this.winConditionForm.winFloorRangeEnd);

            // 计算区间内第一个有效的倍数楼层
            const firstMultiple = Math.ceil(start / multiple) * multiple;

            if (firstMultiple > end) {
              this.$message.error(
                "该倍数在当前楼层范围内无有效中奖楼层，请调整倍数或范围"
              );
              return;
            }
          } else if (this.winConditionForm.winType == 2) {
            // 输入的中奖楼层尾号，必须能在起始楼层～结束楼层区间内产生至少 1 个有效中奖楼层
            const tailNumber = parseInt(
              this.winConditionForm.winFloorTailNumber
            );
            const start = parseInt(this.winConditionForm.winFloorRangeStart);
            const end = parseInt(this.winConditionForm.winFloorRangeEnd);

            // 查找区间内是否存在以该尾号结尾的楼层
            let hasValidFloor = false;
            // 从起始楼层开始查找，最多检查10个可能的候选楼层
            for (let i = 0; i <= 10; i++) {
              // 计算可能的候选楼层：找到第一个大于等于start且以tailNumber结尾的数
              const candidate =
                Math.ceil(start / 10) * 10 + tailNumber - i * 10;
              if (candidate >= start && candidate <= end && candidate > 0) {
                hasValidFloor = true;
                break;
              }
            }

            if (!hasValidFloor) {
              this.$message.error(
                "该尾号在当前楼层范围内无有效中奖楼层，请调整尾号或范围"
              );
              return;
            }
          }
          this.prizeSetting[this.currentIndex].buildFloorWinConditionDTO = {
            ...this.winConditionForm,
          };
          this.handleCloseWinCondition();
        }
      });
    },
    checkCode(row) {
      // 获取全部口令
      const list = this.codeList
        .filter((item) => item.code)
        .map((item) => item.code);
      row.code = row.code.trim();
      // 检查是否有重复的口令名称
      const duplicates = list.filter((item) => item === row.code);
      if (duplicates.length > 1) {
        this.$message.warning("口令名称不能重复");
        row.code = "";
      }
    },
    removeCode(index) {
      this.codeList.splice(index, 1);
    },
    addCode() {
      if (this.codeList.length >= 20) {
        this.$message.warning("最多只能新增20条口令");
        return;
      }
      this.codeList.push({
        code: "",
        id: new Date().getTime(),
      });
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },
    handleInput(val) {
      // 限制输入正整数（移除非数字字符，禁止以0开头）
      let result = val.replace(/[^\d]/g, "");
      // 如果以0开头且长度大于1，去除前导0
      if (result.length > 0 && result.startsWith("0")) {
        result = result.replace(/^0+/, "");
      }
      console.log(result, "5454");
      return result;
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      // let sizeype = {
      //   1: {
      //     width: 388,
      //     height: 102,
      //   },
      //   2: {
      //     width: 180,
      //     height: 200,
      //   },
      //   3: {
      //     width: 172,
      //     height: 102,
      //   },
      //   4: {
      //     width: 710,
      //     height: 218,
      //   },
      //   5: {
      //     width: 212,
      //     height: 102,
      //   },
      // };
      // const status = await this.imgchecked(
      //   file,
      //   sizeype[type].width,
      //   sizeype[type].height
      // );
      // if (!status) {
      //   return false;
      // }
      return false;
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.url2 = res.data;
          this.$message.success("按钮背景图上传成功");
        }
      }
    },
    initCustomizeData(row) {
      this.customerPaperwork.titleColor = row.rgb || "#ffffff";
      this.customerPaperwork.btnColor = row.rgb2;
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
      }
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //生成规则
    generateRule() {
      let text1 =
          "用户需在活动有效期内，输入有效的盖楼口令，即可成功“盖一层楼”。",
        text2 =
          "楼层号按盖楼成功的时间顺序依次分配：先盖楼者得小楼层号，后盖楼者得大楼层号，楼层唯一、不重复、不跳号。",
        text3 = "盖楼次数限制：\n",
        text3_1 = `（1）每人每日盖楼次数上限：单用户每日最多可盖楼次数不可超${
          this.ruleDTO.oneDayMaxBuildFloorNumber || ""
        }次，当日次数用尽无法继续盖楼。\n`,
        text3_2 = `（2）每人连续盖楼次数上限：单用户每日连续盖楼最多${
          this.ruleDTO.maxContinuousBuildFloorNumber || ""
        }次，达到连续次数上限后，需等待其他用户参与盖楼后方可继续发布。\n`,
        text3_3 = `（3）活动累计盖楼次数上限：单用户在整个活动周期内最多盖楼${
          this.ruleDTO.totalMaxBuildFloorNumber || ""
        }次，累计次数用尽将无法再次参与盖楼。`,
        text4 =
          "活动奖品：同一用户最多仅可中奖 1 次，命中任意奖品后，后续楼层不再触发中奖资格。\n",
        text5 =
          "实时开奖：用户盖楼成功、生成楼层后，立即校验是否命中中奖规则，中奖后将弹出中奖弹窗，可在「我的奖品」中查看奖励。",
        text6 =
          "奖品数量有限，奖品全部发放完毕后用户不可中奖，可正常盖楼互动，但无法获得奖品。",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【注意事项】";
      text3 += text3_1 + text3_2 + text3_3;
      this.prizeSetting.forEach((item, index) => {
        text4 += `（${index + 1}）${item.title}，共${
          item.totalAmount ? item.totalAmount : 1
        }份${
          item.prizeType == 3 ? "，单份奖品价值" + item.price + "元" : ""
        }；${index != this.prizeSetting.length - 1 ? "\n" : ""}`;
      });
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      let Arr1 = [
        firstText,
        [secondText, text1, text2, text3],
        [thirdText, text4, text5, text6],
        [fourthText, precautions],
      ];
      let newText = "";
      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        // 最后一次订单完成时间
        if (
          this.ruleForm.lastOrderCompleteTimeType == 1 &&
          !this.ruleForm.lastOrderCompleteEndDay &&
          !this.ruleForm.lastOrderCompleteStartDay
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }

        if (
          this.ruleForm.lastOrderCompleteTimeType == 2 &&
          !this.ruleForm.lastOrderCompleteStartTime &&
          !this.ruleForm.lastOrderCompleteEndTime
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }
      }
      if (this.ruleDTO.codeSettingType == 0) {
        if (this.codeList.length == 0) {
          return this.$message.warning("请至少新增一个口令");
        }
        const isHas = this.codeList.some((item) => !item.code);
        if (isHas) {
          return this.$message.warning("请完善口令信息");
        }
      }
      if (this.ruleDTO.codeSettingType == 1) {
        if (this.taskDataList.length == 0) {
          return this.$message.warning("请新增任务");
        }
        const isHasCode = this.taskDataList.some((item) => !item.code);
        if (isHasCode) {
          return this.$message.warning("请完善任务口令信息");
        }
      }
      if (
        !this.ruleDTO.oneDayMaxBuildFloorNumber ||
        !this.ruleDTO.maxContinuousBuildFloorNumber ||
        !this.ruleDTO.totalMaxBuildFloorNumber
      ) {
        return this.$message.warning("请输入盖楼限制~");
      }
      if (this.prizeSetting.length == 0) {
        return this.$message.warning("请添加奖品");
      }
      const isHasVal = this.prizeSetting.some(
        (item) => !item.title || !item.totalAmount || !item.prizeType
      );
      const isConditon = this.prizeSetting.some((item) => {
        if (item.buildFloorWinConditionDTO.winType == 0) {
          return !item.buildFloorWinConditionDTO.specifiedWinFloorList.length;
        }
        if (item.buildFloorWinConditionDTO.winType == 1) {
          return (
            !item.buildFloorWinConditionDTO.multipleFloorNumber ||
            !item.buildFloorWinConditionDTO.winFloorRangeStart ||
            !item.buildFloorWinConditionDTO.winFloorRangeEnd
          );
        }
        if (item.buildFloorWinConditionDTO.winType == 2) {
          return (
            !item.buildFloorWinConditionDTO.winFloorRangeStart ||
            !item.buildFloorWinConditionDTO.winFloorRangeEnd
          );
        }
      });
      if (isHasVal) {
        return this.$message.warning("请完善奖品信息");
      }
      if (isConditon) {
        return this.$message.warning("请完善中奖条件");
      }
      console.log("3333");
      if (!this.templateId) {
        return this.$message.warning("请选择活动模板");
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      //新增进店设置校验
      if (this.ruleDTO.goShopSetting == 1 && !this.ruleDTO.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleDTO.goShopSetting == 2) {
        if (!this.ruleDTO.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleDTO.goShopUrl.startsWith("https://") ||
          !this.ruleDTO.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if (this.placementPosition.length == 0) {
        this.$message.warning("请选择活动投放位置！");
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      let ruleDTO = {
        ...this.ruleDTO,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        isForceRemind: this.isForceRemind,
        codes: this.codeList.map((item) => item.code),
      };
      let obj = {
        ...this.ruleForm,
        subType: 79,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList,
      };
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      obj.ruleDTO.orderCompleteLimitCount =
        this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment =
        this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay =
          this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      delete obj.orderCompleteLimitCount;
      delete obj.orderCompleteMaxCount;
      delete obj.orderCompleteLimitPayment;
      delete obj.orderCompleteMaxPayment;
      delete obj.lastOrderCompleteTimeType;
      delete obj.lastOrderCompleteStartDay;
      delete obj.lastOrderCompleteEndDay;
      delete obj.lastOrderCompleteStartTime;
      delete obj.lastOrderCompleteEndTime;
      // 奖品处理
      let prizeListCommon = JSON.parse(JSON.stringify(this.prizeSetting));
      prizeListCommon = prizeListCommon.map((item) => {
        item.buildFloorWinConditionDTO.specifiedWinFloorList = this.getValue(
          item.buildFloorWinConditionDTO.specifiedWinFloorList
        );
        item.prizeType = item.prizeType ? item.prizeType : 0;
        // 提交地址限制：数组转逗号分隔字符串
        if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
          item.commitAddressLimit = item.commitAddressLimit.join(',');
        }
        return item;
      });
      obj.pointActivityPrizeDTOList = prizeListCommon;
      // 任务
      if (this.taskDataList.length) {
        obj.taskList = this.taskDataList.map((item) => {
          const taskObj = {
            activityType: 2,
            taskType: item.type,
            taskValidity: item.taskTime,
            code: item.code,
            taskDoLimit: 1,
          };
          if (item.id) {
            taskObj.id = item.id;
          }
          // 指定时间
          if (item.taskTime == 2) {
            taskObj.startTime = item.startTime;
            taskObj.endTime = item.endTime;
          }
          // 商品
          if (item.skuIds.length) {
            taskObj.skuIds = item.skuIds.join(",");
          }
          if (item.type == 18) {
            taskObj.inviteLimit = item.condition;
            taskObj.taskDoLimit = item.condition2;
          }
          // 浏览会场-跳转链接
          if (item.type == 5) {
            taskObj.jumpUrl = item.jumpUrl;
            taskObj.viewTime = item.viewTime;
            taskObj.giveLimit = item.giveLimit;
          }
          // 好友助力-邀请人数上限
          if (item.type == 8) {
            taskObj.inviteLimit = item.inviteLimit;
          }
          if (item.type == 17) {
            taskObj.activityType = 2;
            taskObj.orderCountType = item.orderCountType;
            taskObj.orderType = item.orderType;
            taskObj.skuType = item.skuType;
            // 指定商品规则提交，老数据无该字段时默认整单计算
            taskObj.statsSkuType = item.statsSkuType || 0;
            taskObj.itemTotalLimit = item.itemTotalLimit;
            taskObj.amtLimit = item.amtLimit;
            taskObj.orderStartTime = item.orderStartTime;
            taskObj.orderEndTime = item.orderEndTime;

            taskObj.giveType = item.giveType;
            taskObj.countType = item.countType;
            taskObj.taskDoType = item.taskDoType;
            taskObj.venderIds = item.venderIds;
            taskObj.stepList = item.stepList;
            taskObj.venderIds = item.venderIds.join(",");
            taskObj.sellerSkuList = item.sellerSkuList.map((item)=>{
              return {
                skuIds: item.skuIds,
                venderId: item.venderId,
              }
            });
            taskObj.orderPaymentType = item.orderPaymentType;
            taskObj.mergeOrder = item.mergeOrder
          }
          if (item.type == 20) {
            taskObj.activityType = 2;
            taskObj.skuType = item.skuType;
            // 指定商品规则提交，老数据无该字段时默认整单计算
            taskObj.statsSkuType = item.statsSkuType || 0;
            taskObj.orderStartTime = item.orderStartTime;
            taskObj.orderEndTime = item.orderEndTime;
            taskObj.countType = item.countType;
            taskObj.stepList = this.taskOrderList;
            taskObj.giveType = 1;
            taskObj.taskDoType = 1;
          }
          // 任务门槛上限
          if (this.conditionValue.includes(item.type)) {
            if (item.type == 12 || item.type == 16) {
              taskObj.giveLimit = item.condition;
              taskObj.taskDoLimit = item.condition2;
            } else if (item.type == 4) {
              // 加购商品
              taskObj.addCartLimit = item.condition;
            } else if (item.type == 17) {
              taskObj.giveLimit = 1;
              if (
                item.orderCountType == 0 ||
                ((item.giveType == 1 || item.giveType == 2) &&
                  item.taskDoType == 1)
              ) {
                taskObj.taskDoLimit = item.condition2;
              } else {
                taskObj.taskDoLimit = 1;
              }
            } else if (item.type == 20) {
              taskObj.taskDoLimit = item.condition2;
            } else {
              taskObj.giveLimit = item.condition;
            }
          }
          if (item.type == 7) {
            taskObj.giveLimit = item.giveLimit;
          }
          if (item.type == 23) {
            taskObj.giveLimit = 1;
            taskObj.searchKeyword = item.searchKeyword;
          }
          return taskObj;
        });
      } else {
        obj.taskList = [];
      }
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeListCommon
              .filter((item) => item.id)
              .map((item) => {
                return {
                  ...item,
                  prizeId: item.id,
                };
              }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            isValidBlackList: obj.isValidBlackList,
            taskList: obj.taskList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
            // 草稿箱保存正式活动删除id
            if (!obj.status) {
              delete obj.id;
            }
          }
          saveOrUpdateBuildingGift(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getBuildingGiftDetail({ id: this.valueRow.id })
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              isKeyActivity,
              placementPosition,
              isValidBlackList,
              taskList,
              studentSatus,
            } = res.data;
            const {
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
              customerPaperwork,
              codes,
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");
            this.ruleForm.condFollow = condFollow ? true : false;
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.isValidBlackList = isValidBlackList;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            this.ruleDTO = ruleDto;
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity || 0;
            this.placementPosition = placementPosition
              ? placementPosition.split(",")
              : ["SHOP"];
            this.ruleForm.orderCompleteLimitCount =
              ruleDto.orderCompleteLimitCount;
            this.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
            this.ruleForm.orderCompleteLimitPayment =
              ruleDto.orderCompleteLimitPayment;
            this.ruleForm.orderCompleteMaxPayment =
              ruleDto.orderCompleteMaxPayment;
            this.ruleForm.lastOrderCompleteTimeType =
              ruleDto.lastOrderCompleteTimeType || 0;
            this.ruleForm.lastOrderCompleteStartDay =
              ruleDto.lastOrderCompleteStartDay;
            this.ruleForm.lastOrderCompleteEndDay =
              ruleDto.lastOrderCompleteEndDay;
            this.ruleForm.lastOrderCompleteStartTime =
              ruleDto.lastOrderCompleteStartTime;
            this.ruleForm.lastOrderCompleteEndTime =
              ruleDto.lastOrderCompleteEndTime;
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            this.templateJson = JSON.parse(res.data.templateJson);

            // 不关联任务口令回显
            this.codeList =
              codes && codes.length > 0
                ? codes.map((item) => {
                    return {
                      code: item,
                      id: new Date().getTime(),
                    };
                  })
                : [];
            if (customerPaperwork) {
              this.customerPaperwork = JSON.parse(customerPaperwork);
            }
            // 任务回显
            const goodsPromise = [];
            if (taskList.length > 0) {
              this.taskDataList = taskList.map((item) => {
                const obj = {
                  id: item.id,
                  type: item.taskType,
                  taskTime: item.taskValidity,
                  condition: null,
                  condition2: null,
                  count: null,
                  endTime: null,
                  startTime: null,
                  skuIds: [],
                  inviteLimit: null,
                  jumpUrl: null,
                  selectGoodsSkuList: [],
                  activityType:
                    item.taskType == 16 ||
                    item.taskType == 17 ||
                    item.taskType == 7
                      ? item.activityType
                      : 1,
                  skuType: 0,
                  statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
                  orderType: 0,
                  orderCountType: 1,
                  itemTotalLimit: null,
                  amtLimit: null,
                  orderEndTime: null,
                  orderStartTime: null,
                  code: item.code,
                  orderPaymentType: 1
                };
                // 指定时间
                if (item.taskValidity == 2) {
                  obj.startTime = item.startTime;
                  obj.endTime = item.endTime;
                }
                // 商品
                if (item.skuIds) {
                  obj.skuIds = item.skuIds.split(",");
                  let skuIdsLength = obj.skuIds.length;
                  let skuIds = obj.skuIds.toString();
                  goodsPromise.push(
                    getTaobaoItemListSku({
                      current: 1,
                      size: skuIdsLength,
                      skuIds: skuIds.split(","),
                    })
                  );
                }
                // 浏览会场-跳转链接
                if (item.taskType == 5) {
                  obj.jumpUrl = item.jumpUrl;
                  obj.viewTime = item.viewTime || 1;
                  obj.giveLimit = item.giveLimit || 1;
                }
                if (item.taskType == 23) {
                  obj.searchKeyword = item.searchKeyword;
                }
                // 好友助力-邀请人数上限
                if (item.taskType == 8) {
                  obj.inviteLimit = item.inviteLimit;
                }
                if (item.taskType == 17) {
                  obj.orderCountType = item.orderCountType;
                  obj.orderType = item.orderType;
                  obj.skuType = item.skuType;
                  // 指定商品规则回显，老数据无该字段时默认整单计算
                  obj.statsSkuType = item.statsSkuType || 0;
                  obj.itemTotalLimit = item.itemTotalLimit;
                  obj.amtLimit = item.amtLimit;
                  obj.orderStartTime = item.orderStartTime;
                  obj.orderEndTime = item.orderEndTime;
                  obj.giveType = item.giveType;
                  obj.countType = item.countType;
                  obj.taskDoType = item.taskDoType;
                  this.taskLevelList = item.stepList
                  obj.venderIds =
                    item.venderIds
                      ? item.venderIds.split(",").map((item) => +item)
                      : [this.venderId];
                  obj.sellerSkuList = item.sellerSkuList&&item.sellerSkuList.length?item.sellerSkuList:[{
                    skuIds: item.skuIds.split(","),
                    venderId: this.venderId,
                    itemList: [],
                  }];
                  if (this.activityData.isCopy||this.isDraftEdit) {
                    // 跨店复制
                    if(obj.venderIds.length>0) {
                      let index = obj.venderIds.findIndex((item)=>{
                        return item == this.venderId
                      })
                      if(index==-1) {
                        obj.venderIds.unshift(Number(this.venderId))
                        obj.sellerSkuList.unshift({
                          venderId: Number(this.venderId),
                          skuIds: [],
                          itemList: [],
                        })
                      }
                    }
                  }
                  obj.selectGoodsSkuList = item.itemList;
                  obj.stepList = item.stepList;
                  obj.orderPaymentType = item.orderPaymentType===null ? 1 : item.orderPaymentType;
                  obj.mergeOrder = item.mergeOrder || false
                }
                if (item.taskType == 20) {
                  obj.skuType = item.skuType;
                  // 指定商品规则回显，老数据无该字段时默认整单计算
                  obj.statsSkuType = item.statsSkuType || 0;
                  obj.orderStartTime = item.orderStartTime;
                  obj.orderEndTime = item.orderEndTime;
                  obj.countType = item.countType;
                  this.taskOrderList =
                    item.stepList && item.stepList.length > 0
                      ? item.stepList
                      : [];
                  this.hasSelectGoods = item.itemList || [];
                  obj.selectGoodsSkuList = item.itemList;
                }
                if (item.taskType == 18) {
                  obj.condition = item.inviteLimit;
                  obj.condition2 = item.taskDoLimit;
                }
                // 任务门槛上限
                const taskTypeObj = this.taskTypeOptions.find(
                  (option) => option.value == item.taskType
                );
                if (this.conditionValue.includes(item.taskType)) {
                  if (item.taskType == 12) {
                    obj.condition = item.giveLimit;
                    obj.condition2 = item.taskDoLimit;
                  } else if (item.taskType == 4) {
                    obj.condition = item.addCartLimit;
                    obj.count = taskTypeObj.taskCount;
                  } else if (item.taskType == 16) {
                    obj.condition = item.giveLimit;
                    obj.condition2 = item.taskDoLimit;
                    obj.activityType = item.activityType;
                  } else if (item.taskType == 17) {
                    obj.activityType = 2;
                    obj.condition = item.giveLimit;
                    obj.condition2 = item.taskDoLimit;
                    obj.count = taskTypeObj.taskCount;
                  } else if (item.taskType == 20) {
                    obj.activityType = 2;
                    obj.condition2 = item.taskDoLimit;
                  } else {
                    obj.condition = item.giveLimit;
                    obj.count = taskTypeObj.taskCount;
                  }
                } else {
                  obj.condition = taskTypeObj.taskCondition;
                  obj.count = taskTypeObj.taskCount;
                }
                if (item.taskType == 7) {
                  obj.giveLimit = item.giveLimit;
                }
                return obj;
              });
              if (goodsPromise.length > 0) {
                Promise.all(goodsPromise).then((res) => {
                  this.taskDataList
                    .filter((item) => item.skuIds && item.skuIds.length)
                    .forEach((item, index) => {
                      item.selectGoodsSkuList = res[index].data.records;
                    });
                });
              }
            }
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
              // 奖品回显
              this.prizeSetting = pointActivityPrizeDTOList.map((item) => {
                if (item.buildFloorWinConditionDTO) {
                  item.buildFloorWinConditionDTO.specifiedWinFloorList =
                    item.buildFloorWinConditionDTO.specifiedWinFloorList.join(
                      ","
                    );
                }
                // 提交地址限制回显：逗号分隔字符串转数字数组
                if (item.commitAddressLimit) {
                  item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                    ? item.commitAddressLimit.split(',').map(Number)
                    : item.commitAddressLimit;
                } else {
                  item.commitAddressLimit = [0];
                }
                return item;
              });
            }
            if (this.activityData.isCopy) {
              this.ruleForm.ruleDescription = "";
            }
            this.templateId = templateId;
            this.getPolite();
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.game-givetips {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .upload-box {
    width: 400px;
    padding: 20px;
    background: #f4f6fa;
    border-radius: 4px 4px 4px 4px;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }

  .bg-wrap {
    width: 80px;
    // overflow: hidden;
    &-img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .invite-box {
    position: relative;
    background-color: #f7f8fa;
    padding: 16px;
    border-radius: 8px;
    .label-style {
      display: inline-block;
      text-align: right;
      flex-shrink: 0;
    }
    .goods-content {
      width: 95%;
    }
    .move-btn {
      position: absolute;
      top: 16px;
      right: 16px;
    }
  }

  .ml12 {
    margin-left: 12px;
  }

  .ml8 {
    margin-left: 8px;
  }
  .mr8 {
    margin-right: 8px;
  }

  .ml20 {
    margin-left: 20px;
  }

  .mlr8 {
    margin: 0 8px;
  }

  .w90 {
    width: 90px;
  }
  .w125 {
    width: 125px;
  }
  .w150 {
    width: 150px;
  }
  .w180 {
    width: 180px;
  }
  .w400 {
    width: 400px;
  }

  .tip-color {
    color: #666;
  }

  .logo-style {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .text-red {
    color: #ff4d4f;
  }
  .size-tip {
    color: #aaaaaa;
    margin-left: 8px;
  }
  .btn_boxs {
    background-color: rgb(248, 249, 252);
    padding: 16px;
    border-radius: 4px;
    width: 500px;
  }
  .limit {
    display: flex;
    align-items: center;
    color: #333333;
  }
  .label-color {
    color: #333333;
  }

  .copywriting {
    display: flex;
    flex-direction: column;
  }

  .goods-box {
    display: flex;
    align-items: center;
    padding: 10px;
    img {
      width: 60px;
      height: 60px;
    }
  }
}

.code-box {
  // margin-top: 16px;
  max-height: 400px;
  overflow-y: auto;
  .code-item {
    margin-top: 12px;
    display: flex;
    align-items: center;
  }
}
.condition-box {
  // display: flex;
  .edit-icon {
    // align-self: flex-end;
    margin-left: 8px;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}

.extra-text {
  color: #ff8e0c;
}

.flex-c {
  display: flex;
  flex-direction: column;
}
/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
</style>
